import {Component, OnInit} from '@angular/core';
import {AuditService} from "./audit.service";
import {AuditFilter} from "./audit-filter";
import {Audit} from "./audit";
import * as moment from "moment";
import {TranslateService} from "@ngx-translate/core";


@Component({
    selector: 'audit-a2',
    providers: [AuditService],
    templateUrl: './audit.component.html'
})
export class AuditComponent implements OnInit {
    audit:Audit;
    actions:string[];

    filterPeriod: any = {
        from: null,
        to: null
    };

    constructor(private _auditService:AuditService, private translator:TranslateService) {
        _auditService.getActions().subscribe(result => {
            this.actions = result
        });
    }

    ngOnInit() {
        this._auditService
            .getPage(null)
            .subscribe(result => {
                this.audit = result
            });
    }

    filterByDateRange = function (audit) {
        return moment(audit.date).isBetween(this.filterPeriod.from, this.filterPeriod.to);
    }

    formatAudit = function (audit) {
        let formattedAudit = {...audit};

        if(audit.parameters.businessHours) {
            const sortOrder = {
                "monday": 1,
                "tuesday": 2,
                "wednesday": 3,
                "thursday": 4,
                "friday": 5,
                "saturday": 6,
                "sunday": 7
            };
            const sortByDay = function (day1, day2) {
                return sortOrder[day1.dayOfWeek.toLowerCase()] - sortOrder[day2.dayOfWeek.toLowerCase()];
            }

            audit.parameters.businessHours.sort(sortByDay).map((schedule) => {
                formattedAudit.parameters[`${schedule.dayOfWeek}`] = `Open ${schedule.hours[0].openingHour} hs. - ${schedule.hours[0].closingHour} hs.`;
            });
            delete formattedAudit.parameters.businessHours;
        }

        if(audit.parameters.ranges) {
            audit.parameters.ranges.map((range, index) => {
                formattedAudit.parameters[`range ${index+1}`] = `${range.name} starts at ${range.startRange}`;
            });
            delete formattedAudit.parameters.ranges;
        }

        if(audit.parameters.price) {
            const intlSettings = {
                currency: 'ARS',
                maximumFractionDigits: 2,
                style: 'currency'
            };

            formattedAudit.parameters.price = Intl.NumberFormat('es-AR', intlSettings)
                                                  .format(audit.parameters.price.bd);
        }

        if(audit.parameters.selectedCategories) {
            const categorySelected = Object.keys(audit.parameters.selectedCategories)[0];

            formattedAudit.parameters.selectedCategories = `${categorySelected}: ${audit.parameters.selectedCategories[categorySelected]}`;
        }

        return formattedAudit;
    }

    filterAudit(filter:AuditFilter) {
        this._auditService
            .getPage(filter)
            .subscribe(result => {
                this.audit = {...result};
            });
    }

    exportAudit(filter:AuditFilter) {
        filter.language = this.translator.currentLang;
        this._auditService
            .getReport(filter);
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/audit/audit.component.ts